import axios from 'axios';
import config from './../config';


console.log('Config',config);
console.log('dddddddddddddddddddddddddddddddddddddddddddd');

export default {
  TOGGLE_LOADING (state) {
    state.callingAPI = !state.callingAPI
  },
  TOGGLE_SEARCHING (state) {
    state.searching = (state.searching === '') ? 'loading' : ''
  },
  SET_USER (state, user) {
    state.user = user
  },
  SET_TOKEN (state, token) {
    state.token = token
  },
  GET_MARCACIONES(state){
    console.log('Consultando marcaciones');

    return 2;



  },
  loadPapeletas(state,userId){
    state.papeletas = userId;
  },

  loadTipoPapeletas(state,data){

    console.log('llenaremos',data);
    state.tipos_papeleta = data;
  },

  selectPapeleta(state,papeleta){

    console.log('***** seleccionamos', papeleta);
    state.papeleta_seleccionada = papeleta;

  },

  editarPapleta(state,papeleta){

    //solucionamos un error
    papeleta.tipopapeleta = papeleta.descripcion
    //formateamos fechas
    let dateTextoF = papeleta.fechaFinal.split('-');
    let tttF = dateTextoF[2].split(' ');
    papeleta.fechaFinal = dateTextoF[0]+'-'+ tttF[0]+'-'+ dateTextoF[1]+' '+tttF[1];


    let dateTextoI = papeleta.fechaInicio.split('-');
    let tttI = dateTextoI[2].split(' ');
    papeleta.fechaInicio = dateTextoI[0]+'-'+ tttI[0]+'-'+ dateTextoI[1]+' '+tttI[1];

    //obtenemos el USER ID que editó
    papeleta.userid = '000018'

    console.log('Despues del truco enviamos' , papeleta);


    axioss.get(config.serverURI + 'aplicaciones/upapeleta',{params : papeleta})
      .then((response)=>{
        let resp  = response.data;
        console.log('Responde',resp);

        if(resp == 0){
          this.$router.push('/papeletas_salida')
        }else{

        }
        console.log('Resultados al editar' ,data);

      })
  },
  selectMarcacion(state,marcacion){
    state.marcacion = marcacion;
  }



}



// WEBPACK FOOTER //
// ./src/store/mutations.js